import { useQuery } from 'react-query'

import { getStarterPricing } from '../models/subscription'

export function useStarterPricing(teamId: string) {
  const { data, refetch } = useQuery(`stripe-starter-pricing-${teamId}`, () => getStarterPricing(teamId), {
    enabled: Boolean(teamId),
    refetchOnWindowFocus: false,
    retry: true,
    retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
  })

  return { pricing: data, refetch }
}
